import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES].GET_ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/executors/:executorId/brigade/',
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES].GET_ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADE]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/executors/:executorId/brigade/:brigadeId/',
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES].CREATE_ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADE]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/executors/:executorId/brigade/',
		requestOptions: {
			method: 'POST',
		},
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES].PUT_ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADE]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/executors/:executorId/brigade/:brigadeId',
		requestOptions: {
			method: 'PUT',
		},
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES].PATCH_ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADE]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/executors/:executorId/brigade/:brigadeId',
		requestOptions: {
			method: 'PATCH',
		},
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES].DELETE_ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADE]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/executors/:executorId/brigade/:brigadeId',
		requestOptions: {
			method: 'DELETE',
		},
	},

}